import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import PartialPaymentTourBannerView from '@/js/common/components/partialPayment/partialPaymentTourBanner/PartialPaymentTourBanner';
import PartialPaymentBannerDgView from '@/js/desktop/components/partialPayment/partialPaymentBannerDg/PartialPaymentBannerDg';

import './assets/styles.scss';
import template from './assets/template.html';

@extendDecorator({
    partialPaymentBannerDg: null,
})
export default class PartialPaymentTourBannerDesktopView extends PartialPaymentTourBannerView {
    initialize(options = {}) {
        this.template = template({
            bannerText: window.appConfig?.cashbackSettings?.desktopBannerText,
            landingUrl: window.appConfig?.cashbackSettings?.landingUrl,
        });
        super.initialize(options);
    }

    openPopup(event) {
        event.preventDefault();

        this.partialPaymentBannerDg = new PartialPaymentBannerDgView({
            countryName: this.viewModel.get('countryName'),
            tourProducts: this.viewModel.get('tourProducts'),
        });

        this.partialPaymentBannerDg?.dialog?.show?.();
    }
}
